import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  '@media print': {
    container: {
      overflow: 'visible !important'
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto'
  }
}));

const MainContent = ({
  children
}: {
  children: Array<React.ReactElement> | React.ReactElement;
}): React.ReactElement => {
  const styles = useStyles();
  return <div className={styles.container}>{children}</div>;
};

export default MainContent;
